module.exports = __webpack_public_path__ + "img/team-07.1512b183.jpg";